const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ValidateEmail = (email: string | undefined): boolean => {
    return regexEmail.test(email ?? '');
};
